import React, { useState, useRef, useEffect, useMemo } from 'react';
import CardLayout from '../../../components/utils/CardLayout';
import { useForm } from "react-hook-form";
import moment from "moment";
import DatePicker from "react-datepicker";
import Calendar2LineIcon from 'remixicon-react/Calendar2LineIcon';
import { useDispatch, useSelector } from 'react-redux';
import shortCodeActions from '../../../redux/shortCodeData/actions'
import networkActions from '../../../redux/network/actions';
import dealerAction from '../../../redux/dealer/actions'
import { isAdmin, isAdminAgent } from '../../../helpers/commonFunction';
import Button from '../../../components/utils/Button';
import SearchBar from '../../../components/utils/SearchBar';
import Table from '../../../components/utils/Table'
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions'
import Tag from '../../../components/utils/Tag';
import Styles from './dailyPlanRequestReport.module.css';
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


const DailyPlanRequestReport = () => {
    const dispatch = useDispatch();
    const { dailyRequestResult, buttonLoading, dailyRequestListLoading } = useSelector((state) => state.dailyPlanRequest);
    const { getDailyPlanRequestList } = dailyPlanRequestActions;
    const { getDealer } = dealerAction;
    const { getActiveNetworkDAilyPlanMapping } = networkActions;
    const { getShortCode } = shortCodeActions;
    const [filterText, setFilterText] = useState("");
    const { tokenData } = useSelector((state) => state.auth);
    const { shortCodeResult } = useSelector((state) => state.shortCode);
    const { networkResultData } = useSelector((state) => state.network);
    const dealerResult = useSelector((state) => state.dealer.dealerResult);
    const TIMEZONE = process.env.REACT_APP_TIMEZONE;
    const datePickerRef = useRef(null);
    const datePickerRef2 = useRef(null);
    const [toDate, setToDate] = useState(new Date())
    const [fromDate, setFromDate] = useState(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000));
    const [searchData, setSearchData] = useState({
        statusID: '',
        serialNumber: '',
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
        dealerID: "",
        networkID: ""
    });
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const { register: registerFilter, handleSubmit: handleSubmit, formState: { errors: filterError }, watch, reset, getValues, setValue } = useForm({ defaultValues: searchData });

    const openDatePicker = () => {
        datePickerRef.current.setOpen(true);
    };
    const openDatePicker2 = () => {
        datePickerRef2.current.setOpen(true);
    };
    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'FROM DATE', key: 'RequestedDtTm' },
        { displayName: 'TO DATE', key: 'toDate' },
        // { displayName: 'AGENT', key: 'agent' },
        { displayName: 'DEALER', key: 'dealer' },
        { displayName: 'STATUS', key: 'Status' },
        { displayName: 'EMAIL', key: 'email' },
        { displayName: 'IMEI', key: 'IMEI' },
        { displayName: 'MSISDN', key: 'MSISDN' },
        { displayName: 'TRANSACTION ID', key: 'TransactionID' },
        { displayName: 'SERIAL NUMBER', key: 'SerialNumber' },
        { displayName: 'NETWORK', key: 'networkName' },
        { displayName: 'SIM TYPE', key: 'simType' }, ,
        { displayName: 'AMOUNT', key: 'amountCharged' },
        { displayName: 'PLAN VALUE', key: 'planValue' },
        { displayName: 'ZIP CODE', key: 'areaCode' },
        { displayName: 'DAYS', key: 'days' },
        { displayName: 'REMARK', key: 'Remark' },
    ];
    useEffect(() => {
        if (networkResultData.length === 1) {
            setValue('networkID', networkResultData[0].ID);
        }
    }, [networkResultData, setValue]);


    useEffect(() => {
        dispatch(getDealer());
        dispatch(getActiveNetworkDAilyPlanMapping());
        dispatch(getShortCode({
            tableName: "activationrequest",
            fieldName: "RequestStatus"
        }));
        const newData = {
            ...searchData,
            toDate: moment(new Date(toDate)).tz(TIMEZONE).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).tz(TIMEZONE).format("YYYY-MM-DD"),
            simType: 25,
        };
        dispatch(getDailyPlanRequestList(newData))
    }, [])

    const onSubmit = (data) => {
        const newData = {
            ...data,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        setSearchData(newData)
        dispatch(getDailyPlanRequestList(newData));
    }

    const filteredItems = Array.isArray(dailyRequestResult) && dailyRequestResult.length > 0 ? dailyRequestResult.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        // Check if any value in the object contains the filterText
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    const data = useMemo(() => {
        if (filteredItems && filteredItems.length) {
            return filteredItems.map((item, key) => {
                let RequestedDtTm = moment(moment(item.RequestedDtTm).format('YYYY-MM-DD'));
                let currentDate = moment(moment().tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DD'));
                let diffInDays = currentDate.diff(RequestedDtTm, 'days');
                return {
                    key: key + 1,
                    TransactionID: item.TransactionID,
                    SerialNumber: item.SerialNumber,
                    networkName: item.NetworkName,
                    dealer: item.DealerName,
                    MSISDN: item.RequestStatus === 12 ? item.MSISDN : '',
                    IMEI: item.IMEI,
                    networkName: item.NetworkName,
                    simType: item.SimTypeValue,
                    email: item.CustomerEmailID,
                    areaCode: item.AreaCode,
                    amountCharged: `$${item.AmountCharged.toFixed(2)}`,
                    days: item.RequestedDays,
                    RequestedDtTm: item.RequestedDtTm !== null ? moment(new Date(item.RequestedDtTm)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                    toDate: item.RequestedToDate !== null ? moment(new Date(item.RequestedToDate)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                    // Status: < Tag color={item.RequestStatus === 13 ? 'badge-danger' : item.RequestStatus === 11 ? 'badge-warning' : item.RequestStatus === 12 ? 'badge-success' : item.RequestStatus === 47 ? 'badge-secondary' : 'badge-secondary'} title={item.RequestStatusValue} />,
                    Status: (
                        <Tag
                            color={(diffInDays < 0 && item.RequestStatus != 13) ? 'badge-info' : (item.ActivationID && item.RequestStatus === 10) ? 'badge-danger' : item.RequestStatus === 13 ? 'badge-danger' : item.RequestStatus === 11 ? 'badge-warning' : item.RequestStatus === 12 ? 'badge-success' : item.RequestStatus === 47 ? 'badge-secondary' : 'badge-secondary'}
                            title={diffInDays < 0 && item.RequestStatus != 13 ? 'Scheduled' : item.RequestStatusValue}
                        />),
                    Remark: item.Remark,
                    planValue: `$${item.PlanValue.toFixed(2)}`,
                }
            });

        } else {
            return [];
        }
    }, [filteredItems]);

    var listData = dailyRequestResult && dailyRequestResult.length > 0 && dailyRequestResult.map((report, key) => {
        let RequestedDtTm = moment(moment(report.RequestedDtTm).format('YYYY-MM-DD'));
        let currentDate = moment(moment().tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DD'));
        let diffInDays = currentDate.diff(RequestedDtTm, 'days');
        return {
            'S No.': key + 1,
            'From Date': report.RequestedDtTm !== null ? moment(new Date(report.RequestedDtTm)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
            'To Date': report.RequestedToDate !== null ? moment(new Date(report.RequestedToDate)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
            'Transaction ID': report.TransactionID,
            'Serial Number': report.SerialNumber,
            IMEI: report.IMEI,
            MSISDN: report.RequestStatus === 12 ? report.MSISDN : '',
            'Network Name': report.NetworkName,
            Email: report.CustomerEmailID,
            'Dealer Name': report.DealerName,
            'Amount': `$${report.AmountCharged.toFixed(2)}`,
            'Plan Value': `$${report.PlanValue.toFixed(2)}`,
            'Sim Type': report.SimTypeValue,
            'Zip Code': report.AreaCode,
            'Requested Days': report.RequestedDays,
            'Request Status': (diffInDays < 0 && report.RequestStatus != 13 ? 'Scheduled' : report.RequestStatusValue),
            Remark: report.Remark,
        };
    });

    const exportToCSV = async () => {
        if (listData.length > 0) {
            const ws = XLSX.utils.json_to_sheet(listData);
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            await FileSaver.saveAs(data, 'Daily_plan_request_report' + fileExtension);
        }
    }


    return (
        <>
            <CardLayout title="Daily Plan Request Report">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row">

                        <div className="col-lg-2 col-md-4 mb-2">
                            <label className='ml-2'> Network <span className='text-danger'>*</span></label>
                            <select
                                className="form-control"
                                placeholder="Select Network"
                                name="networkID"
                                {...registerFilter("networkID", { required: 'Network is required !' })}
                            >
                                <option value="" disabled>Select</option>
                                {networkResultData.length > 0 && networkResultData.map(network => (
                                    <option name="network" value={network.ID} key={network.ID}>
                                        {network.NetworkName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-lg-2 col-md-4 mb-2">
                            <label>Select Status</label>
                            <select className="form-control" id="statusID" name="statusID" placeholder="Select"  {...registerFilter("statusID", {})}>
                                {shortCodeResult && shortCodeResult.length > 0 && <option value="" name="All">All</option>}
                                {shortCodeResult && shortCodeResult.length > 0 &&
                                    shortCodeResult.filter(item => item.ID !== 27 && item.ID !== 32 && item.ID !== 49).map((item, ind) => (<option key={item.ID} value={item.ID}>{item.Value}</option>))
                                }
                            </select>
                        </div>


                        {
                            (isAdmin(tokenData) || isAdminAgent(tokenData)) &&
                            <div className="col-lg-2 col-md-4  mb-2">
                                <label>Select Dealer</label>
                                <select className="form-control" id="dealerID" name="dealerID"  {...registerFilter("dealerID", {
                                })} >
                                    <option value="" name="All">All</option>
                                    {
                                        dealerResult && dealerResult.length && dealerResult.map((item) => {
                                            return <option value={item.ID} key={`dealer${item.ID}`}>{item.DealerName}</option>
                                        })
                                    }
                                </select>
                            </div>
                        }

                        <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                            <label>From Date</label>
                            <Calendar2LineIcon onClick={openDatePicker} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                            <DatePicker
                                ref={datePickerRef}
                                selected={fromDate}
                                className="form-control"
                                onChange={(date) => setFromDate(date)}
                                dateFormat="yyyy-MM-dd"
                                name="fromDate"
                                showMonthDropdown
                                showYearDropdown
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                                value={fromDate}
                            />
                        </div>

                        <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                            <label>To Date</label>
                            <Calendar2LineIcon onClick={openDatePicker2} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                            <DatePicker
                                ref={datePickerRef2}
                                selected={toDate}
                                className="form-control center"
                                onChange={(date) => setToDate(date)}
                                dateFormat="yyyy-MM-dd"
                                name="todate"
                                showMonthDropdown
                                showYearDropdown
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                                value={toDate}
                            />
                        </div>

                        <div className="col-lg-2 col-md-4 mb-2">
                            <label>SIM/Mobile/TXN</label>
                            <input
                                type="text"
                                className="form-control"
                                id="serialNumber"
                                name="serialNumber"
                                placeholder="SIM/Mobile/TXN"
                                {...registerFilter("serialNumber")}
                            />
                        </div>

                        <div className={(isAdmin(tokenData) || isAdminAgent(tokenData)) ? 'col-lg-2 col-md-4 mb-2' : 'col-lg-2 col-md-4'}>
                            <div className={(isAdmin(tokenData) || isAdminAgent(tokenData)) ? "mt-2 d-flex justify-content-start activation-search-btn" : "mt-4"}>
                                <Button title="Search" style="minWidth:80px" buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} loading={buttonLoading} buttonType='submit' />
                            </div>
                        </div>
                    </div>
                </form>
                <hr />
                <div className='d-flex justify-content-between mt-3'>
                    <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                    <Button icon={<DownloadCloud2sLineIcon color='#fff' className='mr-1 excel-btn-1-aidit ' size={'0.9rem'} />} title="Export" style={{ marginRight: "10px" }} buttonClass={`btn ${Styles.exportBtn}  activation-Export-btn`} buttonStyle="primary" onClick={exportToCSV} />
                </div>
                <div id={'DailyPlanRequestReportTable'}>
                    <Table columns={columns} data={data} loading={dailyRequestListLoading} pagination={true} />
                </div>
            </CardLayout>
        </>
    )
}

export default DailyPlanRequestReport
